export default {
  /**
   * File Extension List
   */
  fileExtentionList: [
    "jpeg",
    "jpg",
    "jfif",
    "gif",
    "png",
    "bmp",
    "tiff",
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "txt",
    "odt",
    "rtf",
  ],
  /**
   * File Size Limit 10 MB in bytes.
   */
  fileSizeLimit: 10485760,
  /**
   * File Size Limit 50 MB in bytes
   */
  totalFilesizeLimit: 52428800,
  downloadAppConst: {
    marketingURL: "https://www.monument.co",
    appStoreURL: "https://apps.apple.com/gb/app/monument-bank/id1556211953",
    playStoreURL:
      "https://play.google.com/store/apps/details?id=co.monument.app",
    errorpageMsg: "Internal error occured. Please try after some time.",
  },
}
